module.exports = __webpack_public_path__ + "img/logo_college.73f36e2.png";